var map = {
	"./academy.jpg": 1302,
	"./ace-hardware.jpg": 1303,
	"./acklands-grainger.jpg": 1304,
	"./amazon-uk.png": 1305,
	"./amazon.jpg": 1306,
	"./amazonCA.jpg": 1307,
	"./basics.jpg": 1308,
	"./bjs.jpg": 1309,
	"./cabelas.jpg": 1310,
	"./costco-uk.png": 1311,
	"./costco.jpg": 1312,
	"./de-raat.jpg": 1313,
	"./ferrimax.png": 1314,
	"./home-depot.jpg": 1315,
	"./home-hardware.jpg": 1316,
	"./lowes.jpg": 1317,
	"./ncr-angola.jpg": 1318,
	"./officedepot-officemax.jpg": 1319,
	"./officemax-grand-and-toy.jpg": 1320,
	"./powered-by-hatch.svg": 336,
	"./sams-club.jpg": 1321,
	"./staples.jpg": 1322,
	"./tmall.jpg": 1323,
	"./walmart.jpg": 1324
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1335;



//////////////////
// WEBPACK FOOTER
// ./src/resources/img/where-to-buy ^\.\/.*$
// module id = 1335
// module chunks = 0